// @flow
import React from 'react';
import PersonaLimitsTable from 'common/entity/riderMaster/PersonaLimitsTable';
import RiderPersonaIdInput from 'common/entity/riderMaster/RiderPersonaIdInput';
import RiderPersonaSkills from 'common/entity/riderMaster/RiderPersonaSkills';
import TransactionTimeInput from 'common/entity/generic/TransactionTimeInput';
import type UnitConversionHelper from 'common/helpers/UnitConversionHelper';
import type { RiderPersona } from 'common/models/flow/MasterRiderPersona';
import ReadOnlyField from 'common/entity/generic/ReadOnlyField';
import type { List } from 'immutable';
import type { CustomField } from 'common/models/internal/EntitySettings';
type Props = {
    t: (string, ?Object) => string,
    theme: {},
    riderPersona: ?RiderPersona,
    getRiderPersonaIdFilters: (input: string) => Object,
    unitConverter: UnitConversionHelper,
    customResources: List<CustomField>
};

const RiderPersonaIdInputWithLimits = ({
    t,
    theme,
    unitConverter,
    riderPersona,
    customResources,
    ...rest
}: Props) => {
    const {
        transporterId: { transporterId = '' } = {},
        fleetType = '',
        limits,
        skills
    } = (riderPersona: ?RiderPersona) || {};
    const showLimits = limits ? limits.hasNonEmptyValues() : false;
    const transactionTimePerTask = limits
        ? limits.getIn(['transactionTimePerTask'])
        : null;
    const translatedFleetType = fleetType
        ? t(`masterRiderPersonaProperties.fleetTypes.${fleetType}`)
        : '';
    return (
        <>
            <RiderPersonaIdInput riderPersona={riderPersona} {...rest} />
            {showLimits ? (
                <PersonaLimitsTable
                    t={t}
                    limits={limits}
                    unitConverter={unitConverter}
                    customResources={customResources}
                />
            ) : null}
            {transactionTimePerTask ? (
                <TransactionTimeInput
                    t={t}
                    theme={theme}
                    data={transactionTimePerTask}
                    disabled /* This is a read-only "input" field populated with data derived from rider persona */
                />
            ) : null}
            {skills?.size ? <RiderPersonaSkills t={t} data={skills} /> : null}
            <ReadOnlyField
                value={transporterId}
                label={t('riderForm.transporterId')}
            />
            <ReadOnlyField
                value={translatedFleetType}
                label={t('riderForm.fleetType')}
            />
        </>
    );
};

export default RiderPersonaIdInputWithLimits;
